import { IApiSuccessWrapper, IBaseSettings } from '$/types'
import { apiSlice } from 'app/services/api'

export enum BaseSettingsGroup {
  SiteSettings = 'SiteSettings',
  LookupTables = 'LookupTables',
  GlobalFilterSettings = 'GlobalFilterSettings',
  HCAMCAConfigDetails = 'HCAMCAConfigDetails'
}

export const baseSettingsApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getBaseSettings: build.query<IBaseSettings[], void>({
      query: () => '/basesettings',
      transformResponse: (res: IApiSuccessWrapper<IBaseSettings[]>) => {
        return res.result
      }
    })
  })
})

export const { useGetBaseSettingsQuery } = baseSettingsApi

// #region selectFromResult helpers
type IFindLookupTables = (
  list: IBaseSettings[] | undefined
) => IBaseSettings | undefined

export const findLookupTablesFromBaseSettings: IFindLookupTables = (
  settingsList
) =>
  settingsList?.find(
    (setting) => setting.groupName === BaseSettingsGroup.LookupTables
  )
// #endregion
